import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { ItemsLayoutMainOptions } from '../../configs/main-menu';

/**
 * Landing view rendered inside the shell at the root route.
 * Displays quick-access options to the main sections of the app.
 */
@Component({
  selector: 'kanzi-apes-layout-main-view',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink],
  template: `
    <div class="main-view">
      <h2>{{ 'main_layout.welcome' | translate }}</h2>
      <div class="options">
        <a
          *ngFor="let option of itemsOptions()"
          [routerLink]="option.routerLink"
          class="option-card"
        >
          <i [class]="option.icon"></i>
          <span>{{ option.label | translate }}</span>
        </a>
      </div>
    </div>
  `,
  styles: [
    `
      .main-view {
        padding: 2rem;
      }
      .options {
        display: flex;
        gap: 1rem;
        flex-wrap: wrap;
      }
      .option-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;
        padding: 1.5rem 2rem;
        border-radius: 8px;
        background: var(--surface-card, #fff);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        text-decoration: none;
        color: inherit;
      }
      .option-card i {
        font-size: 2rem;
      }
    `,
  ],
})
export class LayoutMainViewComponent {
  itemsOptions = signal<MenuItem[]>(ItemsLayoutMainOptions);
}
